import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=110526f2&scoped=true"
import script from "./Bundles.vue?vue&type=script&lang=js"
export * from "./Bundles.vue?vue&type=script&lang=js"
import style0 from "./Bundles.vue?vue&type=style&index=0&id=110526f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110526f2",
  null
  
)

export default component.exports